import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a1969f7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a1969f7&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=5a1969f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1969f7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/home/vsts/work/1/s/components/PageHeader.vue').default,Step: require('/home/vsts/work/1/s/components/Step.vue').default,AeqDocumentList: require('/home/vsts/work/1/s/components/AeqDocumentList.vue').default,AeqSelectField: require('/home/vsts/work/1/s/components/AeqSelectField.vue').default,AeqDateField: require('/home/vsts/work/1/s/components/AeqDateField.vue').default,AeqFileField: require('/home/vsts/work/1/s/components/AeqFileField.vue').default,Answer: require('/home/vsts/work/1/s/components/Answer.vue').default,AeqAlertsSettings: require('/home/vsts/work/1/s/components/AeqAlertsSettings.vue').default})
